const LOGO = 'https://cloud.sharemyimage.com/2026/08/16/DayClap-Logo.png';
const APP_ICON = 'https://cloud.sharemyimage.com/2026/08/16/App-Icon.png';
const GRADIENT = 'background: linear-gradient(135deg, #ec4899, #f43f5e)';
const FONT = 'font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif';

const wrapper = (content) => `<!DOCTYPE html>
<html>
<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"></head>
<body style="margin: 0; padding: 0; background: #f9fafb;">
<div style="${FONT}; max-width: 600px; margin: 0 auto; padding: 40px 20px; background: #ffffff;">
  <div style="text-align: center; margin-bottom: 36px;">
    <img src="${LOGO}" alt="DayClap" style="height: 120px;">
  </div>
  ${content}
  <div style="text-align: center; margin-top: 40px; padding-top: 24px; border-top: 1px solid #f3f4f6;">
    <img src="${APP_ICON}" alt="" style="width: 80px; height: 80px; border-radius: 20px; margin-bottom: 8px;">
    <p style="color: #9ca3af; font-size: 12px; margin: 0;">Create something special for someone special. ❤️</p>
    <p style="color: #d1d5db; font-size: 11px; margin: 8px 0 0 0;">DayClap · dayclap.com</p>
  </div>
</div>
</body>
</html>`;

export const emailTemplateLibrary = [
  // ============================================================
  // SECTION A: SUPABASE AUTH TEMPLATES
  // These go into Supabase Dashboard → Authentication → Email Templates
  // They use Supabase native Go template variables:
  //   {{ .ConfirmationURL }} - The confirmation/action URL
  //   {{ .Token }}           - The raw token value
  //   {{ .TokenHash }}       - The token hash
  //   {{ .SiteURL }}         - Your site URL (https://dayclap.com)
  //   {{ .Email }}           - The user's email address
  //   {{ .Data }}            - User metadata (name, avatar, etc.)
  //   {{ .RedirectTo }}      - The redirect URL after action
  // ============================================================

  {
    id: 'supabase-confirm-signup',
    name: '📋 Confirm Signup (Welcome)',
    slug: 'supabase-confirm-signup',
    description: 'Supabase sends this automatically when a new user signs up. Paste into Supabase Dashboard → Authentication → Email Templates → "Confirm signup".',
    subject: 'Confirm your DayClap account ❤️',
    category: 'system',
    icon: '✅',
    isSupabaseTemplate: true,
    supabaseSlot: 'Confirm signup',
    variables: ['{{ .ConfirmationURL }}', '{{ .SiteURL }}', '{{ .Email }}', '{{ .Token }}', '{{ .TokenHash }}', '{{ .Data }}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 28px; text-align: center; margin: 0 0 8px 0;">Welcome to DayClap! ❤️</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi there, we're so happy you're here. DayClap is where you create beautiful, personalized invitations for the people who matter most.</p>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Please confirm your email address by clicking the button below:</p>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{ .ConfirmationURL }}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 44px; border-radius: 12px; font-weight: bold; font-size: 17px;">Confirm Your Email ✓</a>
  </div>

  <div style="background: #fdf2f8; border-radius: 16px; padding: 24px; margin: 24px 0;">
    <p style="color: #831843; font-size: 14px; text-align: center; margin: 0 0 12px 0; font-weight: 600;">What's next?</p>
    <table style="width: 100%; border-collapse: collapse;">
      <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">✨ Create your first invitation</td></tr>
      <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">💌 Personalize it with photos, music & effects</td></tr>
      <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">❤️ Send it to someone special</td></tr>
    </table>
  </div>

  <p style="color: #9ca3af; font-size: 13px; text-align: center;">If you didn't create this account, you can safely ignore this email.</p>
  <p style="color: #d1d5db; font-size: 11px; text-align: center; margin-top: 8px;">Confirmation link: <span style="word-break: break-all;">{{ .ConfirmationURL }}</span></p>`)
  },

  {
    id: 'supabase-reset-password',
    name: '📋 Reset Password',
    slug: 'supabase-reset-password',
    description: 'Supabase sends this when a user requests a password reset. Paste into Supabase Dashboard → Authentication → Email Templates → "Reset password".',
    subject: 'Reset your DayClap password',
    category: 'system',
    icon: '🔐',
    isSupabaseTemplate: true,
    supabaseSlot: 'Reset password',
    variables: ['{{ .ConfirmationURL }}', '{{ .SiteURL }}', '{{ .Email }}', '{{ .Token }}', '{{ .TokenHash }}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Reset Your Password</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">We received a request to reset your DayClap password. Click the button below to set a new one.</p>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{ .ConfirmationURL }}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 44px; border-radius: 12px; font-weight: bold; font-size: 17px;">Reset Password</a>
  </div>

  <div style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 12px; padding: 16px; margin: 24px 0;">
    <p style="color: #92400e; font-size: 13px; text-align: center; margin: 0;">⚠️ This link expires in 1 hour. If you didn't request this, you can safely ignore this email.</p>
  </div>

  <p style="color: #9ca3af; font-size: 12px; text-align: center;">If the button doesn't work, copy and paste this link:<br><span style="color: #6b7280; word-break: break-all;">{{ .ConfirmationURL }}</span></p>`)
  },

  {
    id: 'supabase-magic-link',
    name: '📋 Magic Link Login',
    slug: 'supabase-magic-link',
    description: 'Supabase sends this for magic link authentication. Paste into Supabase Dashboard → Authentication → Email Templates → "Magic link".',
    subject: 'Your DayClap login link ✨',
    category: 'system',
    icon: '🔗',
    isSupabaseTemplate: true,
    supabaseSlot: 'Magic link',
    variables: ['{{ .ConfirmationURL }}', '{{ .SiteURL }}', '{{ .Email }}', '{{ .Token }}', '{{ .TokenHash }}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Your Login Link ✨</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Click the button below to sign in to DayClap. This link is valid for one use only.</p>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{ .ConfirmationURL }}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 44px; border-radius: 12px; font-weight: bold; font-size: 17px;">Sign In to DayClap</a>
  </div>

  <p style="color: #9ca3af; font-size: 13px; text-align: center;">If you didn't request this link, you can safely ignore this email.</p>`)
  },

  {
    id: 'supabase-email-change',
    name: '📋 Email Change Confirmation',
    slug: 'supabase-email-change',
    description: 'Supabase sends this when a user changes their email. Paste into Supabase Dashboard → Authentication → Email Templates → "Change email address".',
    subject: 'Confirm your new DayClap email',
    category: 'system',
    icon: '📧',
    isSupabaseTemplate: true,
    supabaseSlot: 'Change email address',
    variables: ['{{ .ConfirmationURL }}', '{{ .SiteURL }}', '{{ .Email }}', '{{ .Token }}', '{{ .TokenHash }}', '{{ .NewEmail }}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Confirm Email Change</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">You requested to change your DayClap email address. Click the button below to confirm your new email.</p>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{ .ConfirmationURL }}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 44px; border-radius: 12px; font-weight: bold; font-size: 17px;">Confirm New Email</a>
  </div>

  <p style="color: #9ca3af; font-size: 13px; text-align: center;">If you didn't request this change, please secure your account immediately.</p>`)
  },

  // ============================================================
  // SECTION B: APP-SENT TEMPLATES (via Emailit API edge function)
  // These are sent programmatically from the app using the
  // send-email edge function. They use custom variables that
  // are replaced by the edge function's string replacement.
  // These CANNOT use Supabase variables — Supabase doesn't send them.
  // ============================================================

  {
    id: 'invitation-sent',
    name: 'Invitation Received',
    slug: 'invitation-received',
    description: 'Sent via Emailit API to the recipient when someone sends them an invitation. Includes a button to open and view.',
    subject: 'You have a special invitation! 💌',
    category: 'transactional',
    icon: '💌',
    isAppTemplate: true,
    variables: ['{{recipient_name}}', '{{sender_name}}', '{{occasion}}', '{{invite_url}}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 28px; text-align: center; margin: 0 0 8px 0;">You have something special! 💌</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi <strong>{{recipient_name}}</strong>, <strong>{{sender_name}}</strong> created a special invitation just for you.</p>

  <div style="background: linear-gradient(135deg, #fdf2f8, #fce7f3); padding: 32px; border-radius: 20px; margin: 28px 0; text-align: center; border: 1px solid #fbcfe8;">
    <p style="color: #be185d; font-size: 12px; text-transform: uppercase; letter-spacing: 1px; margin: 0 0 8px 0;">Invitation For</p>
    <p style="color: #831843; font-size: 22px; font-weight: bold; margin: 0 0 4px 0;">{{occasion}}</p>
    <p style="color: #9d174d; font-size: 14px; margin: 0;">From {{sender_name}} → {{recipient_name}}</p>
  </div>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{invite_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 44px; border-radius: 12px; font-weight: bold; font-size: 17px;">Open Invitation ❤️</a>
  </div>

  <p style="color: #9ca3af; font-size: 13px; text-align: center;">Someone special took the time to create something just for you. Don't leave them waiting!</p>`)
  },

  {
    id: 'invitation-opened',
    name: 'Invitation Opened',
    slug: 'invitation-opened',
    description: 'Sent via Emailit API to the sender when the recipient opens/views their invitation for the first time.',
    subject: '{{recipient_name}} opened your invitation! 👀',
    category: 'transactional',
    icon: '👀',
    isAppTemplate: true,
    variables: ['{{sender_name}}', '{{recipient_name}}', '{{occasion}}', '{{app_url}}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Your invitation was opened! 👀</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Great news, <strong>{{sender_name}}</strong>! <strong>{{recipient_name}}</strong> just opened your <strong>{{occasion}}</strong> invitation.</p>

  <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 16px; padding: 24px; margin: 28px 0; text-align: center;">
    <p style="font-size: 40px; margin: 0 0 8px 0;">📬</p>
    <p style="color: #1e40af; font-size: 14px; margin: 0;">They're reading it right now... fingers crossed! 🤞</p>
  </div>

  <p style="color: #6b7280; font-size: 14px; text-align: center; line-height: 1.6;">You'll get another notification when they respond. Stay tuned!</p>

  <div style="text-align: center; margin: 28px 0;">
    <a href="{{app_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 14px 32px; border-radius: 12px; font-weight: bold; font-size: 15px;">Check Status</a>
  </div>`)
  },

  {
    id: 'invitation-accepted',
    name: 'Invitation Accepted',
    slug: 'invitation-accepted',
    description: 'Sent via Emailit API to the sender when the recipient accepts their invitation. Celebrates the YES!',
    subject: "It's a YES! 🎉❤️",
    category: 'transactional',
    icon: '🎉',
    isAppTemplate: true,
    variables: ['{{sender_name}}', '{{recipient_name}}', '{{occasion}}', '{{app_url}}'],
    html: wrapper(`
  <div style="text-align: center; margin-bottom: 16px;">
    <p style="font-size: 56px; margin: 0;">🎉</p>
  </div>
  <h1 style="color: #1f2937; font-size: 32px; text-align: center; margin: 0 0 8px 0;">It's a YES! ❤️</h1>
  <p style="color: #6b7280; font-size: 18px; line-height: 1.6; text-align: center;">Great news, <strong>{{sender_name}}</strong>!</p>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;"><strong>{{recipient_name}}</strong> accepted your <strong>{{occasion}}</strong> invitation!</p>

  <div style="background: linear-gradient(135deg, #f0fdf4, #dcfce7); border: 1px solid #bbf7d0; border-radius: 20px; padding: 28px; margin: 28px 0; text-align: center;">
    <p style="color: #166534; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">They said YES! 💚</p>
    <p style="color: #15803d; font-size: 14px; margin: 0;">Time to plan something amazing together.</p>
  </div>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{app_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 16px 40px; border-radius: 12px; font-weight: bold; font-size: 16px;">Plan Your Date 💕</a>
  </div>`)
  },

  {
    id: 'invitation-declined',
    name: 'Invitation Declined',
    slug: 'invitation-declined',
    description: 'Sent via Emailit API to the sender when the recipient declines their invitation. Encouraging and supportive tone.',
    subject: 'Invitation update from DayClap',
    category: 'transactional',
    icon: '💔',
    isAppTemplate: true,
    variables: ['{{sender_name}}', '{{recipient_name}}', '{{occasion}}', '{{app_url}}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Invitation Update</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi <strong>{{sender_name}}</strong>, your <strong>{{occasion}}</strong> invitation to <strong>{{recipient_name}}</strong> was declined.</p>

  <div style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 16px; padding: 24px; margin: 28px 0; text-align: center;">
    <p style="font-size: 32px; margin: 0 0 8px 0;">💪</p>
    <p style="color: #991b1b; font-size: 14px; margin: 0;">Don't worry — there are many more special moments ahead. Every "no" brings you closer to the right "yes".</p>
  </div>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{app_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 16px 40px; border-radius: 12px; font-weight: bold; font-size: 16px;">Create Another ❤️</a>
  </div>

  <p style="color: #9ca3af; font-size: 13px; text-align: center;">The bravest thing you can do is put yourself out there. We're proud of you.</p>`)
  },

  {
    id: 'invitation-reminder',
    name: 'Invitation Reminder',
    slug: 'invitation-reminder',
    description: 'Sent via Emailit API to the recipient as a gentle reminder if they haven\'t responded to an invitation yet.',
    subject: 'You have a pending invitation from {{sender_name}} 💌',
    category: 'transactional',
    icon: '⏰',
    isAppTemplate: true,
    variables: ['{{recipient_name}}', '{{sender_name}}', '{{occasion}}', '{{invite_url}}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Don't forget! 💌</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi <strong>{{recipient_name}}</strong>, you have a pending invitation from <strong>{{sender_name}}</strong> that's waiting for your response.</p>

  <div style="background: #fffbeb; border: 1px solid #fde68a; border-radius: 16px; padding: 24px; margin: 28px 0; text-align: center;">
    <p style="color: #92400e; font-size: 14px; margin: 0 0 4px 0; font-weight: 600;">{{occasion}}</p>
    <p style="color: #a16207; font-size: 13px; margin: 0;">Someone is eagerly waiting for your answer! 😊</p>
  </div>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{invite_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 16px 40px; border-radius: 12px; font-weight: bold; font-size: 16px;">View & Respond ❤️</a>
  </div>

  <p style="color: #9ca3af; font-size: 13px; text-align: center;">It only takes a moment to make someone's day.</p>`)
  },

  {
    id: 'connection-established',
    name: 'Connection Established',
    slug: 'connection-established',
    description: 'Sent via Emailit API to both parties when an invitation is accepted and a connection is established.',
    subject: "You're connected! 🎊",
    category: 'transactional',
    icon: '🔗',
    isAppTemplate: true,
    variables: ['{{user_name}}', '{{partner_name}}', '{{occasion}}', '{{app_url}}'],
    html: wrapper(`
  <div style="text-align: center; margin-bottom: 16px;">
    <p style="font-size: 48px; margin: 0;">🎊</p>
  </div>
  <h1 style="color: #1f2937; font-size: 28px; text-align: center; margin: 0 0 8px 0;">You're Connected!</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Amazing, <strong>{{user_name}}</strong>! You and <strong>{{partner_name}}</strong> are now connected through your <strong>{{occasion}}</strong> invitation.</p>

  <div style="background: linear-gradient(135deg, #faf5ff, #f3e8ff); border: 1px solid #e9d5ff; border-radius: 20px; padding: 28px; margin: 28px 0; text-align: center;">
    <p style="color: #6b21a8; font-size: 14px; margin: 0 0 12px 0; font-weight: 600;">What you can do now:</p>
    <table style="width: 100%; border-collapse: collapse;">
      <tr><td style="padding: 6px 0; color: #7c3aed; font-size: 13px;">💬 Plan your special moment together</td></tr>
      <tr><td style="padding: 6px 0; color: #7c3aed; font-size: 13px;">📅 Set a date and location</td></tr>
      <tr><td style="padding: 6px 0; color: #7c3aed; font-size: 13px;">✨ Create more invitations</td></tr>
    </table>
  </div>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{app_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 16px 40px; border-radius: 12px; font-weight: bold; font-size: 16px;">Go to DayClap ❤️</a>
  </div>`)
  },

  {
    id: 'event-reminder',
    name: 'Event Date Reminder',
    slug: 'event-reminder',
    description: 'Sent via Emailit API to both sender and recipient as a reminder before the event date.',
    subject: 'Your {{occasion}} is coming up! 📅',
    category: 'transactional',
    icon: '📅',
    isAppTemplate: true,
    variables: ['{{user_name}}', '{{partner_name}}', '{{occasion}}', '{{event_date}}', '{{event_time}}', '{{location}}', '{{app_url}}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Your event is coming up! 📅</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi <strong>{{user_name}}</strong>, your <strong>{{occasion}}</strong> with <strong>{{partner_name}}</strong> is almost here!</p>

  <div style="background: #f0f9ff; border: 1px solid #bae6fd; border-radius: 16px; padding: 24px; margin: 28px 0;">
    <table style="width: 100%; border-collapse: collapse;">
      <tr>
        <td style="padding: 8px 0; border-bottom: 1px solid #e0f2fe;">
          <span style="color: #64748b; font-size: 12px;">📅 Date</span><br>
          <span style="color: #0c4a6e; font-size: 15px; font-weight: 600;">{{event_date}}</span>
        </td>
      </tr>
      <tr>
        <td style="padding: 8px 0; border-bottom: 1px solid #e0f2fe;">
          <span style="color: #64748b; font-size: 12px;">🕐 Time</span><br>
          <span style="color: #0c4a6e; font-size: 15px; font-weight: 600;">{{event_time}}</span>
        </td>
      </tr>
      <tr>
        <td style="padding: 8px 0;">
          <span style="color: #64748b; font-size: 12px;">📍 Location</span><br>
          <span style="color: #0c4a6e; font-size: 15px; font-weight: 600;">{{location}}</span>
        </td>
      </tr>
    </table>
  </div>

  <div style="text-align: center; margin: 36px 0;">
    <a href="{{app_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 16px 40px; border-radius: 12px; font-weight: bold; font-size: 16px;">View Details</a>
  </div>`)
  },

  {
    id: 'account-deletion',
    name: 'Account Deletion Confirmation',
    slug: 'account-deletion',
    description: 'Sent via Emailit API when a user requests account deletion. Confirms the action and provides a grace period.',
    subject: 'Your DayClap account deletion request',
    category: 'system',
    icon: '🗑️',
    isAppTemplate: true,
    variables: ['{{name}}', '{{app_url}}', '{{cancel_url}}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Account Deletion Request</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi <strong>{{name}}</strong>, we received a request to delete your DayClap account.</p>

  <div style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 16px; padding: 24px; margin: 28px 0;">
    <p style="color: #991b1b; font-size: 14px; text-align: center; margin: 0 0 12px 0; font-weight: 600;">⚠️ This action cannot be undone</p>
    <p style="color: #b91c1c; font-size: 13px; text-align: center; margin: 0;">Your account and all associated data (invitations, connections, profile) will be permanently deleted after 48 hours.</p>
  </div>

  <div style="text-align: center; margin: 28px 0;">
    <a href="{{cancel_url}}" style="display: inline-block; background: #374151; color: white; text-decoration: none; padding: 14px 32px; border-radius: 12px; font-weight: bold; font-size: 15px;">Cancel Deletion</a>
  </div>

  <p style="color: #9ca3af; font-size: 13px; text-align: center;">If you didn't request this, please secure your account immediately.</p>
  <p style="color: #9ca3af; font-size: 12px; text-align: center;">We're sorry to see you go. ❤️</p>`)
  },

  {
    id: 'profile-update',
    name: 'Profile Updated',
    slug: 'profile-updated',
    description: 'Sent via Emailit API when a user updates their profile information. Confirms the changes made.',
    subject: 'Your DayClap profile was updated ✓',
    category: 'system',
    icon: '✏️',
    isAppTemplate: true,
    variables: ['{{name}}', '{{app_url}}'],
    html: wrapper(`
  <h1 style="color: #1f2937; font-size: 24px; text-align: center; margin: 0 0 8px 0;">Profile Updated ✓</h1>
  <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi <strong>{{name}}</strong>, your DayClap profile has been successfully updated.</p>

  <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 16px; padding: 24px; margin: 28px 0; text-align: center;">
    <p style="font-size: 32px; margin: 0 0 8px 0;">✅</p>
    <p style="color: #166534; font-size: 14px; margin: 0;">Your changes have been saved successfully.</p>
  </div>

  <p style="color: #6b7280; font-size: 14px; text-align: center;">If you didn't make this change, please secure your account by updating your password.</p>

  <div style="text-align: center; margin: 28px 0;">
    <a href="{{app_url}}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 14px 32px; border-radius: 12px; font-weight: bold; font-size: 15px;">View Profile</a>
  </div>`)
  },

  {
    id: 'test-email',
    name: 'Email Test',
    slug: 'test-email',
    description: 'A test email sent from the admin panel to verify that the Emailit API email sending service is working.',
    subject: 'DayClap Email Test ✅',
    category: 'system',
    icon: '🧪',
    isAppTemplate: true,
    variables: ['{{recipient_email}}', '{{timestamp}}'],
    html: wrapper(`
  <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 16px; padding: 28px; text-align: center; margin-bottom: 24px;">
    <p style="font-size: 40px; margin: 0 0 8px 0;">✅</p>
    <h2 style="color: #166534; font-size: 20px; margin: 0 0 8px 0;">Email Sending is Working!</h2>
    <p style="color: #15803d; font-size: 14px; margin: 0;">This is a test email from the DayClap admin panel.</p>
  </div>

  <div style="background: #f9fafb; border-radius: 12px; padding: 20px; margin: 24px 0;">
    <p style="color: #374151; font-size: 13px; margin: 0 0 12px 0; font-weight: 600;">Test Details:</p>
    <table style="width: 100%; border-collapse: collapse;">
      <tr><td style="padding: 6px 0; color: #6b7280; font-size: 13px;">📧 Sent to: <strong>{{recipient_email}}</strong></td></tr>
      <tr><td style="padding: 6px 0; color: #6b7280; font-size: 13px;">🕐 Sent at: <strong>{{timestamp}}</strong></td></tr>
      <tr><td style="padding: 6px 0; color: #6b7280; font-size: 13px;">⚙️ Service: Emailit API via Supabase Edge Function</td></tr>
    </table>
  </div>

  <p style="color: #9ca3af; font-size: 12px; text-align: center;">If you received this, your DayClap email configuration is working perfectly. ❤️</p>`)
  }
];